import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

export default function Contact() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav activeItem="Contact" />

      <section className="py-24 bg-slate-50" data-testid="contact-page">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-accent mb-4">GET IN TOUCH</p>
            <h1 className="text-5xl sm:text-6xl tracking-tighter font-light text-brand-primary font-outfit mb-6">Contact Us</h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">Have questions or need assistance? We're here to help!</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="space-y-8"
            >
              <div className="bg-white p-8 border border-slate-200">
                <div className="flex items-start space-x-4">
                  <Phone className="h-8 w-8 text-brand-accent" />
                  <div>
                    <h3 className="text-lg font-medium text-brand-primary mb-2">Phone</h3>
                    <p className="text-slate-600 mb-1">+92-301-7196699</p>
                    <a href="https://wa.me/923017196699" className="text-brand-accent hover:text-brand-accent-hover" data-testid="contact-whatsapp-link">
                      WhatsApp Available
                    </a>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 border border-slate-200">
                <div className="flex items-start space-x-4">
                  <Mail className="h-8 w-8 text-brand-accent" />
                  <div>
                    <h3 className="text-lg font-medium text-brand-primary mb-2">Email</h3>
                    <p className="text-slate-600">info@zanaqua.com</p>
                    <p className="text-slate-600">support@zanaqua.com</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 border border-slate-200">
                <div className="flex items-start space-x-4">
                  <MapPin className="h-8 w-8 text-brand-accent" />
                  <div>
                    <h3 className="text-lg font-medium text-brand-primary mb-2">Address</h3>
                    <p className="text-slate-600">A-6 Commercial Market</p>
                    <p className="text-slate-600">Phase II, Agrics Town</p>
                    <p className="text-slate-600">Raiwind Road, Lahore, Pakistan</p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-8 border border-slate-200">
                <div className="flex items-start space-x-4">
                  <Clock className="h-8 w-8 text-brand-accent" />
                  <div>
                    <h3 className="text-lg font-medium text-brand-primary mb-2">Business Hours</h3>
                    <p className="text-slate-600">Monday - Saturday: 09:00 AM - 8:00 PM</p>
                    <p className="text-slate-600">Sunday: 12:00 PM - 8:00 PM</p>
                  </div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-white p-8 border border-slate-200"
            >
              <h3 className="text-2xl font-medium text-brand-primary mb-6">Quick Order</h3>
              <p className="text-slate-600 mb-6">For quick orders, contact us via WhatsApp and we'll get your water delivered within minutes!</p>
              <a
                href="https://wa.me/923017196699?text=Hi,%20I'd%20like%20to%20order%20water"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block w-full bg-brand-accent text-white hover:bg-brand-accent-hover px-8 py-3 shadow-sm transition-all duration-200 text-center"
                data-testid="order-whatsapp-button"
              >
                Order via WhatsApp
              </a>

              <div className="mt-8 pt-8 border-t border-slate-200">
                <h4 className="text-lg font-medium text-brand-primary mb-4">Delivery Coverage</h4>
                <p className="text-slate-600 mb-4">We provide free home delivery within a 5 KM radius of our plant. Same-day delivery available for orders placed before 8:00 PM.</p>
                <div className="bg-brand-cyan-light p-4">
                  <p className="text-sm text-brand-primary font-medium">💧 Free Delivery within 5 KM</p>
                  <p className="text-sm text-brand-primary font-medium">⚡ Same-day delivery available</p>
                  <p className="text-sm text-brand-primary font-medium">🏆 Quality guaranteed</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}